import script from "./PreSportFeaturedFixtures.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportFeaturedFixtures.vue?vue&type=script&setup=true&lang=js"

import "./PreSportFeaturedFixtures.vue?vue&type=style&index=0&id=2b5390c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5390c3"]])

export default __exports__